import { NotificationsReducerStateInterface } from '../../models';

export const notificationsInitialState: NotificationsReducerStateInterface = {
  notifications: []
};
